import React from "react";
import Icon from "@ant-design/icons";

const ViewDetailSvg = () => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        fill="none"
        viewBox="0 0 16 16"
    >
        <circle cx="7.99961" cy="7.99961" r="6.4" fill="#165ABF" stroke="#165ABF" />
        <path
            fill="#F9FBFE"
            stroke="#F9FBFE"
            strokeWidth="0.5"
            d="M8.39961 5.20078C8.39961 5.4217 8.22052 5.60078 7.99961 5.60078C7.7787 5.60078 7.59961 5.4217 7.59961 5.20078C7.59961 4.97987 7.7787 4.80078 7.99961 4.80078C8.22052 4.80078 8.39961 4.97987 8.39961 5.20078Z"
        />
        <path
            stroke="#F9FBFE"
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M8 11.1992L8 7.19922"
        />
    </svg>
);

const ViewDetailIcon = (props) => (
    <Icon component={ViewDetailSvg} {...props} />
);

export { ViewDetailIcon };